
import {Component, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import AuditTrailTable from "@/components/audittrail/AuditTrailTable.vue";
import {
  auditTrailModule,
  currentUserModule,
  queryModule,
} from "@/store";

import {formatDateTime} from "@/auxillary/date-format";
import IQueryDto = MdbsCore.IQueryDto;

@Component({
  components: {AuditTrailTable}
})
export default class QueryAuditTrailView extends Vue {
  @Prop({default: ""}) private queryId: string;

  query: IQueryDto | null = null;

  get querySequenceId() {
    return this.query?.sequenceId ?? "";
  }

  get currentUserDetails() {
    return (currentUserModule.user?.userName ?? "") + " (" + (currentUserModule.roleIdentifier ?? "") + ") " + formatDateTime((new Date().toUTCString()))
  }

  get changes() {
    return auditTrailModule.auditChanges ?? [];
  }

  async mounted() {
    await currentUserModule.loadIfEmpty();
    this.query = await queryModule.loadQuery(this.queryId);
    await auditTrailModule.loadForQuery(this.queryId)
  }

  async back() {
    await this.$router.push({
      name: "query-overview"
    })
  }
}
